// extracted by mini-css-extract-plugin
export default {"package-list":"VerticalFeaturePackageList--package-list--hWa7n","packageList":"VerticalFeaturePackageList--package-list--hWa7n","item":"VerticalFeaturePackageList--item--Qc1ES"};